import { createTheme, ThemeProvider } from "@mui/material";
import "./App.css";
import Router from "./routes/Router";

const defaultTheme = createTheme({});

const App = () => (
  <ThemeProvider theme={defaultTheme}>
    <Router />
  </ThemeProvider>
);

export default App;
